module.exports = __webpack_public_path__ + "media/new_message.88384aec.mp3";